{
  "common": {
    "saveChanges": "ENREGISTRER LES MODIFICATIONS",
    "savingChanges": "ENREGISTREMENT EN COURS...",
    "cancel": "ANNULER",
    "title": "Connectez-vous",
    "signIn": "CONNEXION",
    "save": "Enregistrer",
    "troubleSigningIn": "Problème de connexion?",
    "resetPassword": "Réinitialiser le mot de passe",
    "email": "Courriel",
    "password": "Mot de passe",
    "findFieldByName": "Trouver un champ par nom...",
    "find": "Trouver",
    "by": "Par",
    "choose": "Choisir...",
    "selectPeriod": "Sélectionner une période...",
    "reasonForRetiring": "Raison du retrait",
    "selectReason": "Sélectionner la raison...",
    "selectAll": "Tout sélectionner",
    "clearAll": "Tout effacer",
    "selectedCount_one": "{{count}} sélectionné",
    "selectedCount_other": "{{count}} sélectionnés",
    "otherReasonDescription": "Veuillez préciser la raison",
    "address": "Adresse",
    "addressContinued": "Adresse (continuée)",
    "city": "Ville",
    "stateProvince": "État / Province",
    "postalCode": "Code postal",
    "requiredField": "* Champ obligatoire",
    "apply": "APPLIQUER",
    "applying": "APPLIQUANT...",
    "clear": "EFFACER",
    "filters": "Filtrer",
    "loading": "Chargement...",
    "yes": "Oui",
    "no": "Non",
    "close": "Fermer",
    "after": "après",
    "viewDashboard": "Afficher le tableau de bord",
    "enterName": "Entrez un nom",
    "alreadyHaveAccount": "Vous avez déjà un compte?",
    "enterEmailAssociatedWithAccount": "Entrez l'adresse e-mail associée à votre compte et nous vous enverrons un lien pour réinitialiser votre mot de passe.",
    "restartPageTour": "Redémarrer la visite guidée",
    "status": "État",
    "name": "Nom",
    "active": "Actif",
    "retired": "Retiré",
    "all": "Tout",
    "comments": "Commentaires",
    "finalized": "Finalisé",
    "firstReportingPeriod": "Première période de déclaration",
    "lastReportingPeriod": "Dernière période de déclaration",
    "theLastReportingPeriod": "la dernière période de déclaration",
    "retire": "Retirer",
    "retireButton": "RETIRER",
    "retiringButton": "RETRAIT EN COURS...",
    "program": "Programme",
    "reportingPeriod": "Période de rapports",
    "totalKwh": "kWh Totaux",
    "clientName": "Nom du client",
    "remittanceMethod": "Méthode de versement",
    "generalInfo": "Informations générales",
    "facility": "Installation",
    "facilities": "Installations",
    "unsavedFilters": "Les filtres n'ont pas été appliqués"
  },
  "language": {
    "en": "English",
    "fc": "Français"
  }
}
